import { AUTH_HEADERS } from '@libs/core';
import { getAccessToken } from '@libs/api-proxy-client/utils';
import { client } from '../../client';
import { CWEA_ENDPOINTS } from '../../constants';
import type { AccountOrdersSuccessResponse } from '@libs/common-next';

export async function getOrders() {
    const token = getAccessToken();

    if (!token) {
        return null;
    }

    const url = CWEA_ENDPOINTS.orders.getOrders;
    return await client.cwea<AccountOrdersSuccessResponse[]>(url, {
        headers: {
            [AUTH_HEADERS.AUTHORIZATION]: `Bearer ${token}`,
        },
        withLocale: true,
    });
}
